import { render, staticRenderFns } from "./CorporateAlbum.vue?vue&type=template&id=1ee45096&scoped=true"
import script from "./CorporateAlbum.vue?vue&type=script&lang=js"
export * from "./CorporateAlbum.vue?vue&type=script&lang=js"
import style0 from "./CorporateAlbum.vue?vue&type=style&index=0&id=1ee45096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee45096",
  null
  
)

export default component.exports